import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _defineProperty from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import { payrollStaffList, payrollStaffExport, saveYearIncomeArchive, checkYearIncomeArchive } from '@/api/payroll';
import searchPopup from '../compontents/search-popup';
import uploadDialog from './modal/uploadDialog';
import SettingSalary from './modal/setting-salary';
import ChangeSalary from './modal/change-salary';
import itemDetail from '../compontents/detail';
import Pagination from '@/components/pagination';
import ExportExcelDialog from '@/components/ExportExcelDialog';
export default {
  name: 'payrollWage',
  components: _defineProperty({
    searchPopup: searchPopup,
    uploadDialog: uploadDialog,
    itemDetail: itemDetail,
    SettingSalary: SettingSalary,
    ChangeSalary: ChangeSalary,
    Pagination: Pagination
  }, ExportExcelDialog.name, ExportExcelDialog),
  data: function data() {
    return {
      exportLoading: false,
      loading: false,
      dialogVisible: false,
      tableData1: [],
      dataForm: {
        search_word: '',
        department_id: '',
        settlement_type: '',
        formal: '',
        state: '',
        hire_start_date: '',
        hire_end_date: '',
        leave_start_date: '',
        leave_end_date: ''
      },
      pageSizes: [20, 50, 100],
      pageName: 'salary',
      staffId: null,
      type: 'salay',
      sort: '',
      dir: '',
      page: {
        list: [{}],
        currPage: 1,
        limit: 20,
        total: 0
      },
      data: {
        year: ''
      },
      isShowExportExcelDialog: false,
      backupsDialogVisible: false,
      loadingBackups: false,
      backupsInfo: {
        year: '',
        operate_date: ''
      }
    };
  },
  created: function created() {
    this.getListData();
  },
  computed: _objectSpread(_objectSpread({}, mapState({
    contentViewHeight: function contentViewHeight(state) {
      return state.settings.contentViewHeight;
    }
  })), {}, {
    tableHeight: function tableHeight() {
      return this.contentViewHeight - 176;
    }
  }),
  methods: {
    // 排序
    handlerSort: function handlerSort(_ref) {
      var prop = _ref.prop,
        order = _ref.order;
      this.sort = prop;
      this.dir = order;
      this.getListData();
    },
    getListData: function getListData() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this.loading = true;
              _context.next = 3;
              return payrollStaffList(_objectSpread(_objectSpread({}, _this.dataForm), {}, {
                sort: _this.sort,
                // 排序相关
                dir: _this.dir,
                page: _this.page.currPage,
                page_size: _this.page.limit
              }));
            case 3:
              res = _context.sent;
              if (res && res.code === 1) {
                _this.page.list = res.data.list;
                _this.page.total = Number(res.data.total_count);
              }
              _this.loading = false;
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    handleSubmit: function handleSubmit() {
      this.page.currPage = 1;
      this.getListData();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.page.limit = val;
      this.getListData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.page.currPage = val;
      this.getListData();
    },
    handleSearch: function handleSearch() {
      this.$refs.searchPopup.init();
    },
    handleImport: function handleImport() {
      this.$refs.uploadDialog.init();
    },
    handleBatchSalary: function handleBatchSalary() {
      this.$router.push({
        path: '/payroll/salaryBatch'
      });
    },
    // 年度数据归档
    handleFile: function handleFile() {
      this.dialogVisible = true;
    },
    getSearchData: function getSearchData(data) {
      this.dataForm = data;
      this.page.currPage = 1;
      this.page.limit = 100;
      this.getListData();
    },
    handleExport: function handleExport() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this2.exportLoading = true;
              _context2.next = 3;
              return payrollStaffExport(_this2.dataForm);
            case 3:
              res = _context2.sent;
              if (res && res.code === 1) window.open(res.data.file_url, '_parent');
              _this2.exportLoading = false;
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    handleSaveYear: function handleSaveYear() {
      var _this3 = this;
      this.$refs.saveYear.validate(function (valid) {
        if (valid) {
          checkYearIncomeArchive({
            year: _this3.data.year
          }).then(function (res) {
            if (res && res.code === 1) {
              if (res.data.operate_date && res.data.year) {
                _this3.dialogVisible = false;
                _this3.backupsInfo.operate_date = res.data.operate_date;
                _this3.backupsInfo.year = res.data.year;
                setTimeout(function () {
                  _this3.backupsDialogVisible = true;
                }, 500);
              } else saveYearIncomeArchive({
                year: _this3.data.year
              }).then(function (res) {
                if (res && res.code === 1) {
                  _this3.$message({
                    message: _this3.$t('818'),
                    type: 'success'
                  });
                  _this3.dialogVisible = false;
                }
              });
            }
          });
        } else return false;
      });
    },
    // 备份并归档
    handleBackups: function handleBackups() {
      var _this4 = this;
      this.loadingBackups = true;
      saveYearIncomeArchive({
        year: this.data.year
      }).then(function (res) {
        if (res && res.code === 1) {
          _this4.$message({
            message: res.message,
            type: 'success'
          });
          _this4.backupsDialogVisible = false;
        }
      }).finally(function () {
        _this4.loadingBackups = false;
      });
    },
    handleEdit: function handleEdit(row) {
      this.staffId = row.staff_id;
      this.$refs.detail.init(row);
    },
    handleSalary: function handleSalary(row) {
      this.$refs.changeSalary.init(row);
    },
    handleSalaryHistory: function handleSalaryHistory(row) {
      this.$router.push({
        path: '/payroll/salaryHistory/' + row.staff_id
      });
    },
    handleSalaryRecord: function handleSalaryRecord(row) {
      this.$router.push({
        path: '/payroll/salaryRecord/' + row.staff_id,
        query: {
          type: row.settlement_type
        }
      });
    },
    handleCommand: function handleCommand(relation_type) {
      var params = {
        relation_type: relation_type
      };
      if (this.dataForm.settlement_type) {
        // 1月 2日结 99其他
        params.settlement_type = this.dataForm.settlement_type;
      }
      var data = +relation_type === 1 ? {} : this.dataForm;
      this.$refs.ExportExcelDialog.init(params, data);
    }
  }
};